var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// require('moment');
// require('bootstrap-five');
// import * as Popper from "@popperjs/core"
// require('bootstrap-five/js/dist/alert');
// require('bootstrap-five/js/dist/button');
// require('bootstrap-five/js/dist/carousel');
// require('bootstrap-five/js/dist/util');
// require('bootstrap-five/js/dist/collapse');
require('bootstrap-five/js/dist/dropdown');
// require('bootstrap-five/js/dist/modal');
// require('bootstrap-five/js/dist/popover');
// require('bootstrap-five/js/dist/scrollspy');
// require('bootstrap-five/js/dist/tab');
// require('bootstrap-five/js/dist/tooltip');

// import Swiper from 'swiper/bundle';
require('mmenu-js');

// require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');

// require('magnific-popup');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

$(function() {


    if ($('.testimonialSwiper').length) {
        const swiper = new Swiper(".testimonialSwiper", {
            slidesPerView: 4,
            spaceBetween: 36,
            // loop: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {

                0: {
                    slidesPerView: 1,
                    spaceBetween: 36,
                },
                540: {
                    slidesPerView: 2,
                    spaceBetween: 36,
                },
                720: {
                    slidesPerView: 3,
                    spaceBetween: 36,
                },
                1140: {
                    slidesPerView: 4,
                    spaceBetween: 36,
                },
            },
        })
    };

	$(window).on('resize load scroll', function() {
        // var headerHeight = $('.navbar--main').outerHeight();
		var scroll = $(window).scrollTop();
        if (scroll >= 5 ) {  //scroll top menu out of view
			$('.navbar--main').addClass("down");
		} else {
			$('.navbar--main').removeClass("down");
		}
	});

});


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Infinite Ajax Scroll
}


document.addEventListener(
"DOMContentLoaded", () => {
    const menu = new Mmenu( "#mob-menu", {

        "extensions": [
            "position-front", "position-right"
        ]
    });

    const api = menu.API;
        document.querySelector( ".close-menu")
        .addEventListener(
            "click", () => {
                api.close();
            }
        );

    }
);
